import { useData } from '../context/DataContext';
import Newsletter from '../components/sections/Newsletter';
import './About.css';

export default function About() {
  const { data, loading } = useData();
  if (loading || !data) return <div className="page">Loading...</div>;
  const { company, team } = data;

  return (
    <main className="page about-page">
      <div className="container">
        <div className="section-title">
          <span className="section-title__label">Who We Are</span>
          <h1 className="section-title__heading">About IWX</h1>
        </div>

        <section className="about-page__intro">
          <div className="about-page__intro-content">
            <p className="about-page__lead">{company.description}</p>
            <div className="about-page__meta">
              <div className="about-page__meta-item">
                <span className="about-page__meta-label">Founded</span>
                <span className="about-page__meta-value">{company.founded}</span>
              </div>
              <div className="about-page__meta-item">
                <span className="about-page__meta-label">Founder</span>
                <span className="about-page__meta-value">{company.founder}</span>
              </div>
              <div className="about-page__meta-item">
                <span className="about-page__meta-label">Headquarters</span>
                <span className="about-page__meta-value">Bangalore, India</span>
              </div>
            </div>
          </div>
        </section>

        <section className="about-page__section">
          <div className="about-page__two-col">
            <div>
              <h2 className="about-page__subtitle">Our Mission</h2>
              <p className="about-page__text">{company.mission}</p>
            </div>
            <div>
              <h2 className="about-page__subtitle">Our Vision</h2>
              <p className="about-page__text">{company.vision}</p>
            </div>
          </div>
        </section>

        <section className="about-page__section">
          <h2 className="about-page__subtitle about-page__subtitle--center">Our Values</h2>
          <div className="about-page__values">
            {company.values.map((value, i) => (
              <div key={i} className="about-page__value">
                <div className="about-page__value-number">{String(i + 1).padStart(2, '0')}</div>
                <h3 className="about-page__value-title">{value.title}</h3>
                <p className="about-page__value-desc">{value.description}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="about-page__section">
          <h2 className="about-page__subtitle about-page__subtitle--center">Our Team</h2>
          <div className="about-page__team">
            {team.map(member => (
              <div key={member.id} className="about-page__member">
                <div className="about-page__member-avatar">{member.avatar}</div>
                <h3 className="about-page__member-name">{member.name}</h3>
                <p className="about-page__member-role">{member.role}</p>
                <p className="about-page__member-desc">{member.description}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
      <Newsletter />
    </main>
  );
}
